/**
 * Shared locale detection logic used by both middleware and server-side functions
 * Keeps the locale detection consistent across the application
 */

export enum LOCALES {
  EN_US = 'en-US',
  EN_CA = 'en-CA',
  FR_CA = 'fr-CA',
  ES_MX = 'es-MX',
  ES_419 = 'es-419',
  PT_BR = 'pt-BR',
}

export const URL_MAP = {
  [LOCALES.EN_US]: [
    // Development
    'dev.nikonusa.com',
    'dev.nikondev.com',
    // QA
    'qa.nikonusa.com',
    'qa.nikondev.com',
    // UAT
    'uat.nikonusa.com',
    'uat.nikondev.com',
    // Production (Pre golive)
    'prd.nikonusa.com',
    // Production
    'www.nikonusa.com',
    'nikonusa.com',
  ],
  [LOCALES.EN_CA]: [
    // Development
    'dev.en.nikon.ca',
    'dev.en.nikondev.ca',
    // QA
    'qa.en.nikon.ca',
    'qa.en.nikondev.ca',
    // UAT
    'uat.en.nikon.ca',
    'uat.en.nikondev.ca',
    // Production
    'en.nikon.ca',
    'www.en.nikon.ca',
  ],
  [LOCALES.FR_CA]: [
    // Development
    'dev.fr.nikon.ca',
    'dev.fr.nikondev.ca',
    // QA
    'qa.fr.nikon.ca',
    'qa.fr.nikondev.ca',
    // UAT
    'uat.fr.nikon.ca',
    'uat.fr.nikondev.ca',
    // Production
    'fr.nikon.ca',
    'www.fr.nikon.ca',
  ],
  [LOCALES.ES_MX]: [
    // Development
    'dev.nikon.com.mx',
    'dev.nikondev.com.mx',
    // QA
    'qa.nikon.com.mx',
    'qa.nikondev.com.mx',
    // UAT
    'uat.nikon.com.mx',
    'uat.nikondev.com.mx',
    // Production
    'www.nikon.com.mx',
    'nikon.com.mx',
  ],
  [LOCALES.ES_419]: [
    // Development
    'dev.nikonamericalatina.com',
    'dev.nikonamericalatinadev.com',
    // QA
    'qa.nikonamericalatina.com',
    'qa.nikonamericalatinadev.com',
    // UAT
    'uat.nikonamericalatina.com',
    'uat.nikonamericalatinadev.com',
    // Production
    'www.nikonamericalatina.com',
    'nikonamericalatina.com',
  ],
  [LOCALES.PT_BR]: [
    // Development
    'dev.nikon.com.br',
    'dev.nikondev.com.br',
    // QA
    'qa.nikon.com.br',
    'qa.nikondev.com.br',
    // UAT
    'uat.nikon.com.br',
    'uat.nikondev.com.br',
    // Production
    'www.nikon.com.br',
    'nikon.com.br',
  ],
};

/**
 * Detects locale based on host domain
 * @param host - The host string (may include port)
 * @returns The detected locale
 */
export const detectLocaleFromHost = (host: string): string => {
  console.log(`[LOCALE_DETECTION] Processing host: "${host}"`);
  // Normal logic: return the appropriate locale based on the domain
  for (const [locale, domains] of Object.entries(URL_MAP)) {
    for (const domain of domains) {
      if (host.includes(domain)) {
        console.log(`[LOCALE_DETECTION] Matched domain "${domain}" -> locale: ${locale}`);
        return locale;
      }
    }
  }

  // Fallback to default locale
  return LOCALES.EN_US;
};
